"use client";

import { useEffect, useState } from "react";
import { Banner } from "./banner";

const products = [
  {
    images: [
      "/images/other.jpg",
      "/images/other2.jpg",
      "/images/other1.jpg",
      "/images/other_spice.jpg",
      "/images/other3.jpg",
      "/images/other4.jpg"],
  },
];

const features = [
  "Coal Fly Ash",
  "Cement",
  "Rice",
  "Spices"
];

export default function Other() {
  const imagesPerSlide = 2;
  const totalSlides = Math.ceil(products[0].images.length / imagesPerSlide);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const goToSlide = (index) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex(index);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? totalSlides - 1 : currentIndex - 1;
    goToSlide(newIndex);
  };

  const goToNext = () => {
    const newIndex = currentIndex === totalSlides - 1 ? 0 : currentIndex + 1;
    goToSlide(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) goToNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex, isAnimating]);

  return (
    <>
      <Banner page={'Products'} heading={'Other Products'} image={"/images/slider.jpg"} />

      <div className="relative w-full max-w-7xl mx-auto px-4 py-12 overflow-hidden">
        <div className="relative overflow-hidden">
          <h3 className="text-4xl font-bold text-center mb-5 lg:mb-10">Product Features</h3>

          <div className="flex items-center gap-4">
            <div className="relative w-full overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                  <div key={slideIndex} className="flex-shrink-0 w-full grid grid-cols-2 gap-4">
                    {products[0].images
                      .slice(slideIndex * imagesPerSlide, slideIndex * imagesPerSlide + imagesPerSlide)
                      .map((image, idx) => (
                        <div key={idx} className="w-full h-96 overflow-hidden rounded-md shadow-lg">
                          <img src={image} alt={`Product ${idx + 1}`} className="object-cover w-full h-full" />
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="mt-8 flex flex-col justify-center space-y-6 mb-10 w-full lg:w-10/12 m-auto">
            <div className="space-y-2  text-center my-5 lg:my-10">
              <h3 className="text-4xl font-bold">Other Products</h3>
              <p className="text-muted-foreground">
                Diverse range of industrial chemicals and materials catering to various sectors, including Coal Fly Ash, Cement, Rice, and Spices.
              </p>
            </div>
            <div className="space-y-3  text-center">
              <ul className="grid grid-cols-2 gap-2 w-full lg:w-[90%] place-self-center">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    <span className="text-xl">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
